var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    paddingTop: _vm.addTopPadding + 'em',
  })},[_c('div',{attrs:{"id":"default-main-wrapper"}},[_c('div',{attrs:{"id":"main-container"}},[_c('default-header',{on:{"add-top-padding":_vm.addHeaderTopPadding}}),_c('section',{attrs:{"id":"app-main"}},[_vm._t("default")],2),(!_vm.hideChannelLinkFooter)?_c('channelLinkFooter'):_vm._e(),_c('default-footer')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }